export const validarQueNoExistaEnLista = (listaNegra, valorTarget) => {
    for (let i = 0; i < listaNegra.length; i++) {
        if (JSON.stringify(listaNegra[i]) === JSON.stringify(valorTarget)) {
            return false;
        }
    }
    return true;
}